import { useQuery } from '@tanstack/react-query';
import { commonQueries } from '@/_api/common/query';

export const useMenuProfile = () => {
  const {
    data: menuProfileData,
    isLoading: isLoadingMenuProfile,
    error: menuProfileError,
    isSuccess: isMenuProfileSuccess,
  } = useQuery({
    queryKey: commonQueries.keys.menuProfile(),
    queryFn: () => commonQueries.fn.fetchMenuProfile(),
    enabled: true,
    staleTime: 5 * 60 * 1000, // 5 dakika cache
    retry: 3,
  });

  const userId = menuProfileData?.body?.id;
  const userProfile = menuProfileData?.body;

  return {
    userId,
    userProfile,
    menuProfileData,
    isLoadingMenuProfile,
    menuProfileError,
    isMenuProfileSuccess,
  };
};
